import styled, { css } from 'styled-components';
import button from 'assets/buttons/green/green_button.png';
import buttonHover from 'assets/buttons/green/green_button_hover.png';
import buttonClicked from 'assets/buttons/green/green_button_clicked.png';

export const Button = styled.div`
  background: url(${button}) no-repeat center;
  background-size: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #004e0f;
  cursor: pointer;
  font-weight: 800;
  font-size: 1.1em;
  margin: auto;
  gap: 0.4rem;
  height: 54px;
  width: ${({ $isModal }) => ($isModal ? '190px' : '165px')};
  &:hover {
    background: url(${buttonHover}) no-repeat center;
    background-size: contain;
  }
  &:active {
    background: url(${buttonClicked}) no-repeat center;
    background-size: contain;
  }
`;

export const Icon = styled.img`
  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `};
  ${({ $withTransition }) =>
    $withTransition &&
    css`
      transition: 0.2s;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    `};
  width: ${({ width }) => width || 40}px;
`;

export const Text = styled.span`
  font-size: ${({ $size }) => $size || 1}em;
  font-weight: ${({ $weight }) => $weight || 500};
`;

export const pageContainerMixin = css`
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
`;
